import { ReactNode } from "react";
import { AccountMenu } from "@/modules/common/widgets/account-menu";
import { Logo } from "@/modules/common/widgets/logo";
import { MobileMenu } from "./mobile-menu/mobile-menu";
import { UserFeedback } from "@/shared/user-feedback";
import { CreateAnnouncementBtn } from "@/modules/feed/widgets/create-new-announcement";
import { NotificationBell } from "@/modules/common/widgets/notification-bell";
import { AskAiAssistant } from "@/modules/ai/features/ask-ai-assistant";

export default function Header() {
  return (
    <HeaderView
      account={<AccountMenu />}
      logo={<Logo />}
      newAnnouncement={<CreateAnnouncementBtn />}
      notifications={<NotificationBell />}
      userFeedback={<UserFeedback />}
      aiHelp={<AskAiAssistant />}
      // search={<Search />}
    />
  );
}

function HeaderView({
  account,
  logo,
  newAnnouncement,
  notifications,
  search,
  userFeedback,
  aiHelp,
}: {
  logo: ReactNode;
  search?: ReactNode;
  newAnnouncement: ReactNode;
  notifications: ReactNode;
  account: ReactNode;
  userFeedback: ReactNode;
  aiHelp: ReactNode;
}) {
  return (
    <header className="h-full items-center grid grid-cols-6 gap-x-6  xl:grid-cols-12">
      <div className="col-span-3 flex justify-start items-center gap-5 xl:hidden">
        <MobileMenu />
        <div>{logo}</div>
      </div>
      <div className="hidden xl:block xl:col-span-2">{logo}</div>
      <div className="xl:col-span-3 only-desktop">{search}</div>
      <div className="col-span-3 xl:col-span-7">
        <div className="flex items-center justify-end space-x-5">
          <div className="only-desktop">{newAnnouncement}</div>
          <div>{notifications}</div>
          <div>{userFeedback}</div>
          <div>{aiHelp}</div>
          <div>{account}</div>
        </div>
      </div>
    </header>
  );
}
